/**
 * Афиша-гифка: Next.js всё равно не оптимизирует анимированные изображения,
 * поэтому такие афиши отдаём напрямую, минуя оптимизатор.
 */
export function isAnimatedPoster(logo: string): boolean {
    try {
        return new URL(logo, 'https://placeholder.local').pathname.toLowerCase().endsWith('.gif');
    } catch {
        return false;
    }
}
